// extracted by mini-css-extract-plugin
export default {"container":"countdown_container__dbfev","timer":"countdown_timer__bgwJ2","legend":"countdown_legend__lGMMz"};